import { UpdateAbsenceBody } from '@lmc/ts-common'
import { useMutation, useQueryClient } from 'react-query'
import {
  ABSENCES_QUERY_KEY,
  ABSENCES_URL,
  ABSENCE_DELETE_QUERY_KEY,
} from './queryConstants'
import { postJSON } from 'common/services/api'
import { showToast } from 'common/utils'

type UseAbsenceDeleteProps = {
  absenceId: string | undefined
  onDeleteSuccess?: () => void
}

type UseAbsenceDeleteReturn = {
  deleteAbsence: (values: UpdateAbsenceBody) => Promise<unknown>
  isDeleteLoading: boolean
}

export const useAbsenceDelete = ({
  absenceId,
  onDeleteSuccess,
}: UseAbsenceDeleteProps): UseAbsenceDeleteReturn => {
  const queryClient = useQueryClient()
  const handleError = (err: any) => {
    showToast({
      title: err?.message as string,
      type: 'error',
    })
  }

  // DELETE
  const deleteFunction = async () => {
    return postJSON({
      url: `${ABSENCES_URL}/${absenceId}`,
      method: 'DELETE',
      isRota: true,
    })
  }

  const { mutateAsync: deleteMutation, isLoading: isDeleteLoading } =
    useMutation<unknown, unknown, UpdateAbsenceBody, unknown>(
      [ABSENCE_DELETE_QUERY_KEY, absenceId],
      deleteFunction,
      {
        onSuccess: () => {
          queryClient.invalidateQueries()
          onDeleteSuccess?.()
        },
        onError: (err) => handleError(err),
      }
    )

  const deleteAbsence = async (values: UpdateAbsenceBody) => {
    try {
      const result = await deleteMutation(values)
      queryClient.invalidateQueries(ABSENCES_QUERY_KEY)
      return result
    } catch (err) {
      return err
    }
  }

  return {
    deleteAbsence,
    isDeleteLoading,
  }
}
